export const pluralize = (text?: string | null, count?: number | null) =>
  `${text || ''}${count && count > 1 ? 's' : ''}`;
